import { FC } from 'react';
import { Box, BoxProps } from '@mui/material';

interface IVoltaageBadgeProps extends BoxProps {}

export const VoltaageBadge: FC<IVoltaageBadgeProps> = ({ children, sx, ...props }) => {
	return (
		<Box
			sx={{
				paddingX: 1,
				paddingY: 0.5,
				backgroundColor: 'primary.main',
				borderRadius: 1,
				color: 'common.white',
				...sx
			}}
			{...props}
		>
			{children}
		</Box>
	);
};
